import { observable } from 'mobx';

class ContentPageStore {
  @observable page = {
    id: null,
    moduleId: null,
    name: '',
    content: '',
    published: false,
    liberationType: null,
    liberationDays: null,
    liberationDate: null,
    hasDuration: false,
    durationDays: 0,
    pageLanguage: {
      language: '',
      signLanguage: false
    }
  };

  @observable medias = [];
  @observable attachments = [];
  @observable tags = [];
  @observable complementaryReadings = [];
  @observable academyBadgeType = null;
  @observable hotPassValue = null;
  @observable mediaVideoUrl = null;
  @observable backgroundImage = null;
  snapshot = {};
}

export const makeContentPageStore = () => new ContentPageStore();

export default new ContentPageStore();
